export const assistant = {
  title: "Assistant",
  subtitle: "Ask about your accounts, or tell it what to do. It stages actions for your approval.",
  newChat: "New chat",
  history: "Chats",
  noHistory: "No chats yet",
  untitled: "New chat",
  deleteChat: "Delete chat",
  hello: "Hi {{name}}, how can I help?",
  helloHint: "I can read your inbox, posts and analytics, draft replies and stage bulk actions. Nothing is sent without your approval.",
  suggestions: {
    week: "Summarize this week",
    spam: "Hide spam comments from this week",
    prices: "Reply to unanswered price questions",
    bestTime: "When should I post?",
  },
  placeholder: "Ask anything, or describe a task…",
  send: "Send",
  stop: "Stop",
  dictate: "Dictate",
  dictating: "Listening… tap to stop",
  voiceMode: "Voice mode",
  you: "You",
  bot: "Malfak",
  thinking: "Thinking…",
  copy: "Copy",
  copied: "Copied",
  retry: "Try again",
  error: "The assistant couldn't answer. Try again.",
  disclaimer: "AI can make mistakes. Staged actions always wait for you.",
  staged: {
    title: "Staged action",
    waiting: "Waiting for your approval",
    approve: "Approve",
    reject: "Reject",
    approved: "Approved",
    rejected: "Rejected",
    editDraft: "Edit draft",
    kinds: {
      reply_public: "Public reply",
      reply_private: "Private reply",
      send_message: "Direct message",
      hide: "Hide",
      delete: "Delete",
      bulk: "Bulk action",
    },
  },
  voice: {
    title: "Talk to Malfak",
    back: "Back to chat",
    start: "Tap the orb and start talking",
    idle: "Microphone paused",
    listening: "Listening…",
    listeningPtt: "Listening… release to send",
    transcribing: "Understanding…",
    thinking: "Thinking…",
    speaking: "Speaking: tap to interrupt",
    noSpeech: "I didn't hear anything. Tap the orb to try again.",
    micDenied: "Microphone access was denied. Allow it in your browser's site settings.",
    micMissing: "No microphone found. You can type instead.",
    typeInstead: "Or type a question…",
    settings: "Voice settings",
    handsFree: "Hands-free",
    handsFreeHint: "Stops recording by itself when you pause, then listens again after the answer.",
    pushToTalk: "Push to talk",
    pushToTalkHint: "Hold the orb (or the space bar) while you talk.",
    captions: "Live captions",
    captionsHint: "Shows your words while you talk, using the browser's built-in recognition.",
    captionsUnsupported: "Your browser has no live captions; your words appear when you finish.",
    speakAnswers: "Read answers aloud",
    log: "Conversation",
    emptyLog: "Your turns will appear here.",
    holdSpace: "Hold Space to talk",
    demoVoice: "Demo voice: speech is simulated in mock mode.",
  },
};
